import { ClockIcon } from "@radix-ui/react-icons";
import LogTimeSelectionDrawer from "./logTimeSelectionDrawer";
import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { useState } from "react";

export default function AddInPastButton({
  onSubmit,
  disabled,
  actionLabel,
}: {
  onSubmit: (data: { date: number }) => void;
  disabled: boolean;
  actionLabel: string;
}) {
  const [logTimeSelectionOpen, setLogTimeSelectionOpen] = useState(false);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="icon" stack="left" disabled={disabled}>
          <ClockIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          onClick={() =>
            onSubmit({ date: new Date().getTime() - 1000 * 60 * 5 })
          }
        >
          Před 5 minutami
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() =>
            onSubmit({ date: new Date().getTime() - 1000 * 60 * 10 })
          }
        >
          Před 10 minutami
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() =>
            onSubmit({ date: new Date().getTime() - 1000 * 60 * 15 })
          }
        >
          Před 15 minutami
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() =>
            onSubmit({ date: new Date().getTime() - 1000 * 60 * 30 })
          }
        >
          Před 30 minutami
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() =>
            onSubmit({ date: new Date().getTime() - 1000 * 60 * 60 })
          }
        >
          Před 1 hodinou
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() =>
            onSubmit({
              date: new Date().getTime() - 1000 * 60 * 60 * 2,
            })
          }
        >
          Před 2 hodinami
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setLogTimeSelectionOpen(true)}>
          Vybrat vlastní čas
        </DropdownMenuItem>
      </DropdownMenuContent>
      <LogTimeSelectionDrawer
        isOpen={logTimeSelectionOpen}
        setIsOpen={setLogTimeSelectionOpen}
        actionLabel={actionLabel}
        onSubmit={(data) => {
          onSubmit({ date: data.date });
          setLogTimeSelectionOpen(false);
        }}
      />
    </DropdownMenu>
  );
}
